import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@dreamtree-org/twreact-ui';
import { EmptyState, PageHeader, QueryState, SectionCard, StatusBadge } from '@/components';
import { useQuery } from '@/lib/useQuery';
import { useStorefront } from '../StorefrontContext';

/** The shopper's repairs, newest first, each linking to its tracker (/repair/:id). `limit` caps the list. */
export function RepairList({ repairs, limit = Infinity }) {
  return (
    <ul className="divide-y divide-[var(--app-border)]">
      {repairs.slice(0, limit).map((r) => (
        <li key={r.id}>
          <Link to={`/repair/${r.id}`} className="flex min-h-14 items-center justify-between gap-2 py-2 text-sm hover:opacity-80">
            <span className="min-w-0"><span className="block font-semibold">{r.id} · {r.device.model}</span><span className="block truncate text-xs opacity-70">{r.issue}</span></span>
            <StatusBadge status={r.status} size="xs" />
          </Link>
        </li>
      ))}
    </ul>
  );
}

/**
 * WEB-09 "My repairs" (/account/repairs). Outside the repair booking pages, so it stays
 * reachable while the store has switched repairs off (D101, user decision 2026-11-02):
 * the shopper still finishes the repairs they have. Booking is offered only while it is open.
 */
export default function MyRepairs() {
  const sf = useStorefront();
  const navigate = useNavigate();
  const q = useQuery('sfRepairs', {}, { select: (r) => r.data });
  const canBook = sf.canVisit('/repair');
  return (
    <div className="space-y-4">
      <PageHeader title="My repairs" back={{ label: 'Account', href: '/account' }} actions={canBook ? <Button size="sm" onClick={() => navigate('/repair')}>Book a repair</Button> : null} />
      <QueryState query={q}>
        {(repairs) =>
          !repairs.length ? (
            <EmptyState title="No repairs yet">{canBook ? 'Repairs you book will appear here.' : 'This store is not taking repair bookings right now.'}</EmptyState>
          ) : (
            <SectionCard title="Your repairs">
              <RepairList repairs={repairs} />
            </SectionCard>
          )
        }
      </QueryState>
    </div>
  );
}
